import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useUpdateUserMutation } from "../../redux/userApi";

import { useTranslation } from "react-i18next";

function EditUser({ show, onHide, user }) {
    const { t } = useTranslation();
    const [editData, setEditData] = useState({});
    const [updateUser] = useUpdateUserMutation();

    useEffect(() => {
        if (user) {
            setEditData(user);
        }
    }, [user]);

    const handleEditSave = async () => {
        await updateUser(editData);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('edit_user')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('first_name')}</Form.Label>
                        <Form.Control
                            type="text"
                            value={editData.fname || ""}
                            onChange={(e) => setEditData({ ...editData, fname: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('last_name')}</Form.Label>
                        <Form.Control
                            type="text"
                            value={editData.lname || ""}
                            onChange={(e) => setEditData({ ...editData, lname: e.target.value })}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                    {t('save_changes')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditUser;
